import IdentificationError from './IdentificationError';
class PassportFileSizeIsExceeded extends IdentificationError {
    constructor(options) {
        super('Passport file size exceeds 15mb', options);
    }
}
export default PassportFileSizeIsExceeded;
